"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewTag = void 0;
var _ = require("../..");
var _jsxRuntime = require("react/jsx-runtime");
const NewTag = props => {
  const {
    label,
    isWithSpout = true,
    view = 'default'
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.ItemTag, {
    label: label,
    isWithSpout: isWithSpout,
    angle: "180deg",
    color: "#ffffff",
    gradientFrom: "#58e476",
    gradientTo: "#49d0a3",
    view: view
  });
};
exports.NewTag = NewTag;